
const raise = (expect, param) => {
    throw new Error(
        `Invalid Parameter Type, Expect ${expect} but get ${typeof param}`
    );
};

const isNil = (val) => {
    return val === undefined || val === null;
};

export default {

    isEmptyString(str) {
        if (typeof(str)==='string') {
            return str.trim() === '';
        }
        raise('string', str);
    },

    isEmail(str, allowNoInput = false) {
        if (allowNoInput && (isNil(str) || str === '')) return true;
        if (isNil(str)) return false;
        if (typeof(str)==='string') {
            return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(str);
        }
        raise('string', str);
    },

    isMobileNumber(str, allowNoInput = false) {
        if (allowNoInput && (isNil(str) || str === '')) return true;
        if (isNil(str)) return false;
        if (typeof(str)==='string') {
            return /^(13[0-9]|14[5|7|9]|15[0|1|2|3|5|6|7|8|9]|166|17[1|2|3|5|6|7|8]|18[0|1|2|3|5|6|7|8|9]|19[8|9])\d{8}$/.test(str);
        }
        raise('string', str);
    },

    isIdcardNumber(str, allowNoInput = false) {
        if (allowNoInput && (isNil(str) || str === '')) return true;
        if (isNil(str)) return false;
        if (typeof(str)==='string') {
            return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
                str
            );
        }
        raise('string', str);
    },

    isAge(age, allowNoInput = false) {
        if (allowNoInput && isNil(age)) return true;
        if (isNil(age)) return false;
        if (typeof (age)==='number') {
            return age > 0 && age < 150;
        }
        raise('integer', age);
    }
};
